// GA4 tracking for the PDP recommendation rows (sections/ms-related-products.liquid), with the old and
// the new recommendation logic alike. Publishes custom events through Shopify.analytics, which the
// "GTM + GA4 (mediashop)" pixel maps to view_item_list / select_item and to the list name on add_to_cart
// (docs/pixels/gtm-ga4-pixel.js). Every row includes this file, so it guards against running twice.
(function () {
  if (window.msRelatedTrackingLoaded) return;
  window.msRelatedTrackingLoaded = true;
  if (window.Shopify && window.Shopify.designMode) return;

  // The new logic re-orders the cards after load; report what is shown after that, or after this delay.
  var MERGE_TIMEOUT_MS = 5000;

  function publish(name, data) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === "function") analytics.publish(name, data);
  }

  function shownCards(list) {
    return Array.prototype.filter.call(list.querySelectorAll(".ms-related__grid > .ms-related__item"), function (card) {
      return window.getComputedStyle(card).display !== "none";
    });
  }

  function itemData(card, index) {
    return {
      product_id: card.dataset.productId,
      title: card.dataset.productTitle || "",
      price: Number(card.dataset.productPrice || 0) / 100,
      index: index + 1,
      source: card.dataset.source || "",
    };
  }

  function listData(list) {
    return {
      list_id: list.dataset.msRecoListId,
      list_name: list.dataset.msRecoListName,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "",
    };
  }

  function merged(list) {
    var row = list.querySelector("ms-related-products");
    if (!row || !window.customElements) return Promise.resolve();
    var done = window.customElements.whenDefined("ms-related-products").then(function () {
      return row.ready;
    });
    var timeout = new Promise(function (resolve) {
      window.setTimeout(resolve, MERGE_TIMEOUT_MS);
    });
    return Promise.race([done, timeout]).catch(function () {});
  }

  function trackClicks(list) {
    list.addEventListener(
      "click",
      function (event) {
        var card = event.target.closest(".ms-related__item");
        if (!card) return;
        var cards = shownCards(list);
        var item = itemData(card, cards.indexOf(card));
        var payload = Object.assign(listData(list), { item: item });
        if (event.target.closest('button[type="submit"], button[name="add"]')) {
          publish("mediashop:recommendation_add_to_cart", payload);
        } else if (event.target.closest('a[href*="/products/"]')) {
          publish("mediashop:recommendation_clicked", payload);
        }
      },
      true,
    );
  }

  function trackView(list) {
    var reported = false;
    var observer = new IntersectionObserver(
      function (entries) {
        if (
          reported ||
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        reported = true;
        observer.disconnect();
        merged(list).then(function () {
          var items = shownCards(list).map(itemData);
          if (items.length) publish("mediashop:recommendation_viewed", Object.assign(listData(list), { items: items }));
        });
      },
      { threshold: 0.5 },
    );
    observer.observe(list);
  }

  Array.prototype.forEach.call(document.querySelectorAll("[data-ms-reco-list-id]"), function (list) {
    trackView(list);
    trackClicks(list);
  });
})();
